module.exports = __webpack_public_path__ + "img/Weapon_207.c1467d6a.png";